import { Directive, Pipe, NgModule } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { isValid, printFormat } from 'iban';

import * as ɵngcc0 from '@angular/core';
class ValidatorService {
    static validateIban(c) {
        if (c.value && !isValid(c.value)) {
            return { iban: { value: c.value } };
        }
        return null;
    }
}

class IbanValidatorDirective {
    validate(c) {
        return ValidatorService.validateIban(c);
    }
}
IbanValidatorDirective.ɵfac = function IbanValidatorDirective_Factory(t) { return new (t || IbanValidatorDirective)(); };
IbanValidatorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IbanValidatorDirective, selectors: [["", "ibanValidator", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IbanValidatorDirective, [{
        type: Directive,
        args: [{
                selector: '[ibanValidator]',
                providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }]
            }]
    }], null, null); })();

class IbanFormatterPipe {
    transform(value, args) {
        if (isValid(value)) {
            return printFormat(value, ' ');
        }
        return value;
    }
}
IbanFormatterPipe.ɵfac = function IbanFormatterPipe_Factory(t) { return new (t || IbanFormatterPipe)(); };
IbanFormatterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ibanFormatter", type: IbanFormatterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IbanFormatterPipe, [{
        type: Pipe,
        args: [{
                name: 'ibanFormatter'
            }]
    }], null, null); })();

class AngularIbanModule {
}
AngularIbanModule.ɵfac = function AngularIbanModule_Factory(t) { return new (t || AngularIbanModule)(); };
AngularIbanModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AngularIbanModule });
AngularIbanModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularIbanModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    IbanValidatorDirective,
                    IbanFormatterPipe
                ],
                imports: [],
                exports: [
                    IbanValidatorDirective,
                    IbanFormatterPipe,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularIbanModule, { declarations: [IbanValidatorDirective, IbanFormatterPipe], exports: [IbanValidatorDirective, IbanFormatterPipe] }); })();

/*
 * Public API Surface of angular-iban
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularIbanModule, IbanFormatterPipe, IbanValidatorDirective, ValidatorService };

